import { LOCAL_FAVORITES_STORAGE_KEY } from './constants';
import { getLikes } from './listingDataExtractor';

export const getLocalFavoritesItems = () => {
  if (typeof window === 'undefined') {
    return [];
  }

  try {
    const items = window.localStorage.getItem(LOCAL_FAVORITES_STORAGE_KEY);
    return items ? JSON.parse(items) : [];
  } catch (error) {
    return [];
  }
};

export const setLocalFavoritesItems = items => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.localStorage.setItem(LOCAL_FAVORITES_STORAGE_KEY, JSON.stringify(items));
  } catch (error) {
    // no-op
  }
};

export const removeLocalFavoritesItems = () => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.localStorage.removeItem(LOCAL_FAVORITES_STORAGE_KEY);
  } catch (error) {
    // no-op
  }
};

export const toggleFavoriteId = (ids = [], listingId) => {
  if (!listingId) {
    return ids;
  }

  return ids.includes(listingId) ? ids.filter(id => id !== listingId) : [...ids, listingId];
};

export const isListingFavorited = (favoriteIds = [], listingId) => {
  return Array.isArray(favoriteIds) && !!listingId && favoriteIds.includes(listingId);
};

export const computeLikesCount = ({ listing, favoriteIds = [], currentUserId }) => {
  const likes = getLikes(listing) || [];
  const baseCount = likes.length;

  if (!currentUserId || !listing?.id?.uuid) {
    return baseCount;
  }

  const listingId = listing.id.uuid;
  const isLikedInListing = likes.includes(currentUserId);
  const isFavorited = isListingFavorited(favoriteIds, listingId);

  if (isFavorited && !isLikedInListing) {
    return baseCount + 1;
  }

  if (!isFavorited && isLikedInListing) {
    return Math.max(baseCount - 1, 0);
  }

  return baseCount;
};
